if (!customElements.get('product-feed')) {
  customElements.define('product-feed', class extends HTMLElement {
    constructor() {
      super();

      this.source = this.getAttribute('source');
    }

    connectedCallback() {
      switch (this.source) {
        case 'recently-viewed':
          this.renderRecentlyViewed();
          break;
        case 'favorites':
          this.renderFavorites();
          break;
        case 'you-may-also-like':
          this.renderYouMayAlsoLike();
          break;
        default:
          console.warn(`Unknown source: ${this.source}`);
      }
    }

    get productFeedContainer() {
      return this.querySelector('[product-feed-container]');
    }

    reinitCarousel() {
      const carouselSlider = this.querySelector('carousel-slider');
      if (carouselSlider) {
        carouselSlider.refresh();
      }
    }

    renderProducts(products) {
      products.forEach((product) => {
        const sliderItem = document.createElement('div');
        sliderItem.classList.add('slider__item');

        const productFeedItem = document.createElement('product-feed-item');
        productFeedItem.setAttribute('product-url', product.url);

        sliderItem.appendChild(productFeedItem);
        this.productFeedContainer.appendChild(sliderItem);
      });

      this.reinitCarousel();
    }

    renderFallbackProducts() {
      const productFeedTitle = this.querySelector('[data-product-feed-title]');
      const fallbackTitle = this.getAttribute('fallback-title');

      if (fallbackTitle && productFeedTitle) {
        productFeedTitle.textContent = fallbackTitle;
      }

      const fallbackProductsTemplate = this.querySelector('template[name="fallback-products"]');
      if (!fallbackProductsTemplate) {
        this.remove();
        return;
      }

      const productSliderItems = fallbackProductsTemplate.content.querySelectorAll('.slider__item');
      productSliderItems.forEach((item) => {
        this.productFeedContainer.appendChild(item);
      });

      this.reinitCarousel();
    }

    renderRecentlyViewed() {
      const recentlyViewedData = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
      const recentlyViewedProducts = recentlyViewedData.filter(Boolean);

      if (!recentlyViewedProducts.length) {
        this.renderFallbackProducts();
        return;
      }

      const baseUrl = window.location.origin;
      const products = recentlyViewedProducts.map((productHandle) => {
        return {
          url: `${baseUrl}/products/${productHandle}`
        };
      });

      this.renderProducts(products);
    }

    renderFavorites() {
      const swymData = JSON.parse(localStorage.getItem('swym-products')) || [];
      const swymAllProducts = swymData?.all?.splice(0, 10) || [];

      if (!swymAllProducts.length) {
        this.renderFallbackProducts();
        return;
      }

      const products = swymAllProducts.map((product) => ({
        url: product.du
      }));

      this.renderProducts(products);
    }

    renderYouMayAlsoLike() {
      fetch(this.dataset.ymalUrl, { priority: 'low' }).then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const updatedCarouselSlider = html.querySelector('carousel-slider');
          const currentCarouselSlider = this.querySelector('carousel-slider');
          
          currentCarouselSlider.replaceWith(updatedCarouselSlider);
        });
    }
  });
}

if (!customElements.get('product-feed-item')) {
  customElements.define('product-feed-item', class extends HTMLElement {
    constructor() {
      super();

      this.productUrl = this.getAttribute('product-url');
    }

    connectedCallback() {
      this.fetchProductCard(this.productUrl);
    }

    fetchProductCard(url) {
      const sectionUrl = new URL(url);
      sectionUrl.searchParams.set('section_id', 'product-card');

      fetch(sectionUrl, { priority: 'low' })
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const productCard = html.querySelector('product-block');

          this.appendChild(productCard);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  });
}